import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const OoImportFileRequest = (userId, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}OldOutages/ImportFile`,
		params: { userId },
		data: formData,
		hasLoading: true,
	});
};

export const OoGetLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OldOutages/GetLastUpdate`,
	hasLoading: true,
});

export const OoCompletionOverdueRequest = (userId, userEmail, testEmails) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OldOutages/CompletionOverdue`,
	params: { userId, userEmail, testEmails },
	hasLoading: true,
});

export const OoEndingTodayRequest = (userId, userEmail, testEmails) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OldOutages/EndingToday`,
	params: { userId, userEmail, testEmails },
	hasLoading: true,
});

export const OoPartnerRestrictedRequest = (userId, userEmail, testEmails) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OldOutages/PartnerRestricted`,
	params: { userId, userEmail, testEmails },
	hasLoading: true,
});

export const OoPartnerRestrictedBlacklistRequest = (userId, userEmail, testEmails) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OldOutages/PartnerRestrictedBlacklist`,
	params: { userId, userEmail, testEmails },
	hasLoading: true,
});

export const OoPartnersEmailsRequest = (userId, userEmail, testEmails) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OldOutages/PartnersEmails`,
	params: { userId, userEmail, testEmails },
	hasLoading: true,
});